<template>
  <div class="proofreading-revise-manuscript-page">
    <revising-editor :novel-id="novelId" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import RevisingEditor from "@/components/organisms/proofreading/revising/RevisingEditor.vue";

export default Vue.extend({
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { RevisingEditor },
  props: {
    novelId: String,
  },
});
</script>

<style lang="scss" scoped>
.proofreading-revise-manuscript-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
</style>
